﻿export interface ISubmissionSearchCriteria {
    organizationName: string;
    firstName: string;
    lastName: string;
    submissionStatusTypeCodeName: string;
    excludeSubmissionStatusCIds: number[];
}

export class SubmissionSearchCriteria {
    organizationName: string;
    firstName: string;
    lastName: string;
    submissionStatusTypeCodeName: string;
    excludeSubmissionStatusCIds: number[];
}
